module.exports = __webpack_public_path__ + "img/x-circle-white.b9f6d561.svg";